import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { UserSelectorQuery, SelectedUserSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'
import { dedupe } from '@/helpers/dedupe'

type User = SelectedUserSelectorQuery['users']['nodes'][0]
interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedUserSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<UserSelectorQuery>(Query, { variables: { first: 10 } })

  const { pageInfo, items } = useCombobox<User>({
    pageInfo: data?.users.pageInfo,
    querySelected: selectedData?.users.nodes[0],
    queryCollection: data?.users.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.displayName || item.email,
      detail: item.email
    })
  })

  return (
    <SearchableCombobox
      data={items}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="displayNameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.users.nodes = dedupe([
            ...previousData.users.nodes,
            ...fetchMoreResult.users.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
